import React, { useContext } from 'react';
import Typography from 'core/ui/Typography';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogActions } from '@material-ui/core';
import Box from 'core/ui/Box';
import Texture from 'core/ui/Texture';
import { ButtonPrimary } from 'core/ui/Button';
import { useDispatch, useSelector } from 'react-redux';
import { channelsSelectors } from 'modules/channels';
import useActions from 'modules/map/useActions';
import Modules from 'modules';
import useSelectors from 'modules/map/useSelectors';
import { automationWorkflowsModule } from 'modules/automationWorkflows';
import useChannelStyles from 'core/useChannelStyles';
import notifications from 'modules/notifications';
import DialogTitle from 'core/ui/Dialog/DialogTitle';
import { Controller, useForm } from 'react-hook-form';
import TextFieldRounded from 'core/ui/TextFieldRounded';
import { WorkflowContext } from 'contexts';
import { showAPIError } from 'core/utils/showAPIError';
import { redColor } from 'core/ui/Colors';

export default function ModalTestAction() {
  const { t } = useTranslation();
  const { buttonColor } = useChannelStyles();
  const channel = useSelector((state) => channelsSelectors.getChannel(state));
  const { request } = useActions();
  const loadingTestAction = useSelectors(automationWorkflowsModule, 'loadingTestAction');
  const workFlowContext = useContext(WorkflowContext);

  const { handleSubmit, control } = useForm({ defaultValues: { email: '' } });

  const trigger = workFlowContext?.workflowTypes.find((x) => x?.automationType?.kind === 'trigger');

  const method = () => {
    const func = workFlowContext.currentType?.automationType?.function;
    if (func === 'InternalNotification') {
      return workFlowContext?.formType?.watch('form')?.method;
    }

    return func === 'SendEmail' ? 'email' : 'phone';
  };

  const methodToSend = method();

  const dispatch = useDispatch();

  const submit = (data) => {
    request({
      action: Modules.automationWorkflows.actions.testAction,
      data: {
        ...data,
        ownerableId: channel?.id,
        ownerableType: 'Channel',

        method: methodToSend,
        subject: workFlowContext?.formType?.watch('form')?.subject,
        text:
          workFlowContext?.formType?.watch('form')?.text ||
          workFlowContext?.formType?.watch('form')?.message,
        testWorkflowType: workFlowContext.currentType?.automationType?.function,
        triggerType: trigger?.automationType?.function,
      },
      options: {
        onSuccess: () => {
          dispatch(
            notifications.success(
              t('workflow.message.testAction.success', { method: methodToSend }),
            ),
          );

          close();
        },
        onError: showAPIError,
      },
    });
  };

  const close = () => {
    workFlowContext?.setModalTest({ open: false });
  };

  return (
    <Dialog
      open={workFlowContext.modalTest?.open}
      scroll="body"
      maxWidth="sm"
      fullWidth
      onClose={() => close()}
    >
      <DialogTitle onClose={close}>
        <Typography align="center" color="secondary" variant="h6">
          {t('workflow.testAction')}
        </Typography>
      </DialogTitle>
      <Texture>
        <Box p={6}>
          {methodToSend === 'push' && (
            <Box>
              <Typography align="center" m={2} className="tw-text-lg tw-font-semibold">
                {t('workflow.testAction.pushNotification')}
              </Typography>
            </Box>
          )}
          {methodToSend === 'email' && (
            <Box>
              <Controller
                control={control}
                rules={{
                  required: true,
                }}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                  <TextFieldRounded
                    name="email"
                    error={error}
                    placeholder={t('profile.placeholder.email')}
                    label={t('profile.label.email').toUpperCase()}
                    onChange={onChange}
                    value={value}
                    required
                    bordered
                  />
                )}
                name="email"
              />
            </Box>
          )}
          {methodToSend === 'phone' && (
            <Box>
              <Controller
                control={control}
                rules={{
                  required: true,
                }}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                  <TextFieldRounded
                    name="phone"
                    error={error}
                    placeholder="Enter the full phone"
                    label={t('profile.label.mobilePhone').toUpperCase()}
                    onChange={onChange}
                    value={value}
                    required
                    bordered
                  />
                )}
                name="phone"
              />
            </Box>
          )}
        </Box>
      </Texture>
      <DialogActions>
        <div className="tw-grow">
          <ButtonPrimary disabled={loadingTestAction} buttonColor={redColor} onClick={close}>
            {t('button.close')}
          </ButtonPrimary>
        </div>
        <Box className="tw-flex tw-flex-row tw-items-center">
          <div>
            <ButtonPrimary
              disabled={loadingTestAction}
              buttonColor={buttonColor}
              onClick={() => handleSubmit(submit)()}
            >
              {t('button.send')}
            </ButtonPrimary>
          </div>
        </Box>
      </DialogActions>
    </Dialog>
  );
}

ModalTestAction.propTypes = {};

ModalTestAction.defaultProps = {};
